function MemberPurchaseService($q, BBModel) {
    'ngInject';

    return {
        query(member, params) {
            if (!params) {
                params = {};
            }
            params.no_cache = true;
            const deferred = $q.defer();
            if (!member.$has('purchase_totals')) {
                deferred.reject('member does not have any purchases');
            } else {
                member.$get('purchase_totals', params).then((purchases) => {
                        params.no_cache = false;
                        return purchases.$get('purchase_totals', params).then((purchases) => {
                                purchases = Array.from(purchases).map(purchase =>
                                    new BBModel.PurchaseTotal(purchase));
                                return deferred.resolve(purchases);
                            }
                            , (err) => {
                                if (err.status === 404) {
                                    return deferred.resolve([]);
                                } else {
                                    return deferred.reject(err);
                                }
                            });
                    }
                    , (err) => {
                        if (err.status === 404) {
                            return deferred.resolve([]);
                        } else {
                            return deferred.reject(err);
                        }
                    });
            }
            return deferred.promise;
        }
    };

}

angular
    .module('BBMember')
    .service('MemberPurchaseService', MemberPurchaseService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/_services/member_purchase.service.js